var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFont(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.667969C6.29786 0.667969 6.53932 0.909434 6.53932 1.2073V10.7954C6.53932 11.0932 6.29786 11.3347 6 11.3347C5.70213 11.3347 5.46067 11.0932 5.46067 10.7954V1.2073C5.46067 0.909434 5.70213 0.667969 6 0.667969Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0673828 1.2073C0.0673828 0.909434 0.308848 0.667969 0.606711 0.667969H11.3933C11.6911 0.667969 11.9326 0.909434 11.9326 1.2073V3.00506C11.9326 3.30292 11.6911 3.54439 11.3933 3.54439C11.0954 3.54439 10.854 3.30292 10.854 3.00506V1.74663H1.14604V3.00506C1.14604 3.30292 0.904574 3.54439 0.606711 3.54439C0.308848 3.54439 0.0673828 3.30292 0.0673828 3.00506V1.2073Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06365 10.7954C3.06365 10.4975 3.30512 10.256 3.60298 10.256H8.39701C8.69487 10.256 8.93634 10.4975 8.93634 10.7954C8.93634 11.0932 8.69487 11.3347 8.39701 11.3347H3.60298C3.30512 11.3347 3.06365 11.0932 3.06365 10.7954Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFont);
export default __webpack_public_path__ + "static/media/font.4c08c5e055d30d8f51791e2040998776.svg";
export { ForwardRef as ReactComponent };